export const environment = {
  production: true,
  blauth: {
    clientId: 'bl-firm-support',
    scope: 'BL_T_A BL_ALL_INCLUSIVE BL_CLIENT_MANAGER',
    redirectURI: 'https://workflow-stage.lundify.com/auth',
    env: '', // dev, test, or empty for prod
  },
  // serverUrl: 'https://workflow-stage.lundify.com/BLbs/',
  serverUrlV2: 'https://workflow-stage.lundify.com/api/',
  loginUrl: 'https://workflow-stage.lundify.com/login',
  documentUrl: 'https://docgenerator.k8s-stage.bjornlunden.com',
  blappWeb: 'https://stage.lundify.com',
  chatServer: 'https://chat-app-test.bjornlunden.se',
  version: 'CI_VERSION_TAG',
  name: 'Stage',
  startPageUrl: {
    SE: 'https://www.bjornlunden.se/byststart',
    NL: 'https://bjornlunden.com/nl/kennisbank/workflow/',
  },
  termsOfAggrementUrl: {
    SE: 'https://www.bjornlunden.se/program/avtalsvillkor-redovisningsbyraer',
    NL: 'https://www.bjornlunden.com/nl/privacy-verklaring/lundify/',
  },
  sdkKey: 'Iy_aCNVU7E6IGx-j0R9XvQ/M4eHtrGbkU6TnT8tgiXOgQ',
  sustainabiltyUrl: 'https://staging.wellfish.se',
  messagingUrl: 'wss://centrifugo.blinfo.se/connection/websocket',
  messagingNamespace: 'workflow-stage',
  forms: {
    giveFeedback: {
      sv: 'HR4vJO4X',
      en: 'lSEvcBnT',
      nl: 'IbSu8ytT',
    },
  },
  matomo: {
    active: false,
    siteId: 12, // 12 = test site id
    url: 'https://matomo.blinfo.se/',
    // scriptUrl: 'https://matomo.blinfo.se/matomo.js',
  },
};
